export default "__VITE_ASSET__CFiH3htB__"